import { render } from "./AncestryDontMessageModal.vue?vue&type=template&id=167c3b1a&scoped=true"
import script from "./AncestryDontMessageModal.vue?vue&type=script&lang=js"
export * from "./AncestryDontMessageModal.vue?vue&type=script&lang=js"

import "./AncestryDontMessageModal.vue?vue&type=style&index=0&id=167c3b1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167c3b1a"]])

export default __exports__